import { SquadsRedirect } from 'components/rivals/squads/SquadsRedirect';

const MySquadLeaderboardPage = () => {
  return <SquadsRedirect />;
};
export default MySquadLeaderboardPage;
